import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {Card} from '@jobseeker/lotus/components';
import {Paragraph} from '@jobseeker/lotus/elements';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Link,
  Grid,
  Hidden,
} from '@mui/material';

const CookiePolicyPage = () => {
  const DOMAIN = `${process.env.NEXT_PUBLIC_APP_DOMAIN}`;
  return (
    <Box
      sx={{
        maxWidth: '1050px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Card variant="" heading="">
        <Typography
          sx={{
            fontFamily: 'Poppins',
            fontSize: '24px',
            fontWeight: 500,
            lineHeight: '30px',
            textAlign: 'Center',
            color: 'secondary.dark',
            marginBottom: '40px',
          }}
        >
          COOKIE POLICY
        </Typography>
        <Paragraph
          title="Introduction"
          body={
            <>
              This Cookie Policy (&quot;Policy&quot;) explains that we believe
              in being open and clear about how we use your information. In the
              spirit of transparency, this Policy provides detailed information
              about how and when we use cookies on our websites. This cookie
              policy applies to any {DOMAIN} product or service that links to
              this policy or incorporates it by reference.
            </>
          }
        />

        <Paragraph
          title={<>a. Does {DOMAIN} use cookies?</>}
          body={
            <>
              {DOMAIN} uses cookies, tags and other technologies when you use
              any of the {DOMAIN} websites, mobile sites or mobile apps
              (collectively &quot;the services&quot;). Cookies are used to
              ensure everyone has their best possible experience. Cookies also
              help us keep your account safe. By continuing to visit or use our
              services, you are agreeing to the use of cookies and similar
              technologies for the purposes we describe in this policy. If you
              prefer not to receive cookies or web beacons, then you should stop
              using our site, or consult your browsing and third-party cookie
              settings as described below.
            </>
          }
        />

        <Paragraph
          title="b. What is a cookie?"
          body={
            <>
              Cookies are small pieces of text stored by a website you visit in
              your browser and subsequently sent by your web browser in every
              request to the website. A cookie file is stored in your web
              browser and allows the Site or a third-party to recognize you and
              make your next visit easier and the Site more useful to you.
              Essentially, cookies are a user&apos;s identification card for the{' '}
              {DOMAIN} servers. Cookies allow {DOMAIN} to serve you better and
              more efficiently, and to personalize your experience on our site.
              Web beacons, tags and scripts may be used in the Websites or in
              emails to help us to deliver cookies, count visits, understand
              usage and campaign effectiveness and determine whether an email
              has been opened and acted upon. We may analyse or perform analysis
              based on the use of these technologies and generate reports on an
              individual and aggregated basis.
              <br />
              Cookies can be &quot;persistent&quot; or &quot;session&quot;
              cookies. A persistent cookie helps us recognize you as an existing
              user, so it&apos;s easier to return to {DOMAIN} or interact with
              our services without signing in again. After you sign in, a
              persistent cookie stays in your browser and will be read by{' '}
              {DOMAIN} when you return to one of our sites or a partner site
              that uses our services. Session cookies only last for as long as
              the session (usually the current visit to a website or a browser
              session).
            </>
          }
        />

        <Paragraph
          title="c. What are cookies used for?"
          body={
            <>
              When you visit our websites, we may place a number of cookies in
              your browser. These are known as First Party Cookies and are
              required to hold session information as you navigate from page to
              page within the website. For example, we use cookies on our
              websites to understand visitor and user preferences, improve their
              experience, and track and analyse usage, navigational and other
              statistical information. Additionally, cookies allow us to bring
              you advertising both on and off the {DOMAIN} site, and bring
              customized features to you. You can control the use of cookies at
              the individual browser level. If you elect not to activate the
              cookie or to later disable cookies, you may still visit our
              websites, but your ability to use some features or areas of the
              Websites may be limited. We may use any of the following
              categories of cookies on the Websites as detailed below. Each
              cookie falls within one of the four following categories:
              <br />
              <Grid container spacing={2}>
                <Hidden smDown>
                  <Grid item xs={12}>
                    <TableContainer component={Paper} sx={{fontSize: '14px'}}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              <Typography
                                variant="body1"
                                sx={{fontSize: '14px', fontWeight: 500}}
                              >
                                Category
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography
                                variant="body1"
                                sx={{fontSize: '14px', fontWeight: 500}}
                              >
                                Description
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>
                              <Typography
                                sx={{fontSize: '14px', fontWeight: 500}}
                              >
                                Essential Cookies
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography
                                variant="body1"
                                sx={{fontSize: '14px'}}
                              >
                                Essential cookies (First Party Cookies) are
                                sometimes called &quot;strictly necessary&quot;
                                as without them we cannot provide many services
                                that you need on the Website. For example,
                                essential cookies help remember your preferences
                                as you move around the Website. Essential
                                cookies also keep you logged in into a website.
                                Without them the login functionality would not
                                work.
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography
                                sx={{fontSize: '14px', fontWeight: 500}}
                              >
                                Analytics Cookies
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography
                                variant="body1"
                                sx={{fontSize: '14px'}}
                              >
                                These cookies track information about visits to
                                the {DOMAIN} and partner (recruiter websites)
                                websites so that we can make improvements and
                                report our performance. For example: analyze
                                visitor and user behavior so as to provide more
                                relevant content or suggest certain activities.
                                They collect information about how visitors use
                                the Websites, which site the user came from, the
                                number of each user&apos;s visits and how long a
                                user stays on the Websites. We might also use
                                analytics cookies to test new ads, pages, or
                                features to see how users react to them.
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography
                                sx={{fontSize: '14px', fontWeight: 500}}
                              >
                                Functionality or Preference Cookies
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography
                                variant="body1"
                                sx={{fontSize: '14px'}}
                              >
                                During your visit to the Websites, cookies are
                                used to remember information you have entered or
                                choices you make (such as your username,
                                language or your region) on the Websites. They
                                also store your preferences when personalizing
                                the Websites to optimize your use of {DOMAIN}.
                                These preferences are remembered, through the
                                use of the persistent cookies, and the next time
                                you visit the Websites you will not have to set
                                them again.
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography
                                sx={{fontSize: '14px', fontWeight: 500}}
                              >
                                Targeting or Advertising Cookies
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography
                                variant="body1"
                                sx={{fontSize: '14px'}}
                              >
                                These Cookies are placed by third party
                                advertising platforms or networks or {DOMAIN} in
                                order to, deliver ads and track ad performance,
                                enable advertising networks to deliver ads that
                                may be relevant to you based upon your
                                activities (this is sometimes called
                                &quot;behavioral&quot; &quot;tracking&quot; or
                                &quot;targeted&quot; advertising) on the
                                Websites. They may subsequently use information
                                about your visit to target you with advertising
                                that you may be interested in, on {DOMAIN}{' '}
                                websites or other websites. For example, these
                                cookies remember which browsers have visited the
                                websites.
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Hidden>

                <Hidden mdUp>
                  <Grid item xs={12}>
                    <br />
                    <Paragraph
                      title={<>Category Description</>}
                      body={
                        <>
                          <Paper>
                            <Typography
                              variant="h6"
                              gutterBottom
                              sx={{fontSize: '14px'}}
                            >
                              Essential Cookies
                            </Typography>
                            <Typography
                              variant="body1"
                              paragraph
                              sx={{fontSize: '14px'}}
                            >
                              Essential cookies (First Party Cookies) are
                              sometimes called &quot;strictly necessary&quot; as
                              without them we cannot provide many services that
                              you need on the Website. For example, essential
                              cookies help remember your preferences as you move
                              around the Website. Essential cookies also keep
                              you logged in into a website. Without them the
                              login functionality would not work.
                            </Typography>

                            <Typography
                              variant="h6"
                              gutterBottom
                              sx={{fontSize: '14px'}}
                            >
                              Analytics Cookies
                            </Typography>
                            <Typography
                              variant="body1"
                              paragraph
                              sx={{fontSize: '14px'}}
                            >
                              These cookies track information about visits to
                              the {DOMAIN} and partner (recruiter websites)
                              websites so that we can make improvements and
                              report our performance. For example: analyze
                              visitor and user behavior so as to provide more
                              relevant content or suggest certain activities.
                              They collect information about how visitors use
                              the Websites, which site the user came from, the
                              number of each user&apos;s visits and how long a
                              user stays on the Websites. We might also use
                              analytics cookies to test new ads, pages, or
                              features to see how users react to them.
                            </Typography>

                            <Typography
                              variant="h6"
                              gutterBottom
                              sx={{fontSize: '14px'}}
                            >
                              Functionality or Preference Cookies
                            </Typography>
                            <Typography
                              variant="body1"
                              paragraph
                              sx={{fontSize: '14px'}}
                            >
                              During your visit to the Websites, cookies are
                              used to remember information you have entered or
                              choices you make (such as your username, language
                              or your region) on the Websites. They also store
                              your preferences when personalizing the Websites
                              to optimize your use of {DOMAIN}. These
                              preferences are remembered, through the use of the
                              persistent cookies, and the next time you visit
                              the Websites you will not have to set them again.
                            </Typography>

                            <Typography
                              variant="h6"
                              gutterBottom
                              sx={{fontSize: '14px'}}
                            >
                              Targeting or Advertising Cookies
                            </Typography>
                            <Typography
                              variant="body1"
                              paragraph
                              sx={{fontSize: '14px'}}
                            >
                              These Cookies are placed by third party
                              advertising platforms or networks or {DOMAIN} in
                              order to, deliver ads and track ad performance,
                              enable advertising networks to deliver ads that
                              may be relevant to you based upon your activities
                              (this is sometimes called &quot;behavioral&quot;
                              &quot;tracking&quot; or &quot;targeted&quot;
                              advertising) on the Websites. They may
                              subsequently use information about your visit to
                              target you with advertising that you may be
                              interested in, on {DOMAIN} websites or other
                              websites. For example, these cookies remember
                              which browsers have visited the websites.
                            </Typography>
                          </Paper>
                        </>
                      }
                    />
                  </Grid>
                </Hidden>
              </Grid>
            </>
          }
        />

        <Paragraph
          title={<>d. When does {DOMAIN} place cookies?</>}
          body={
            <>
              We use cookies on our websites, mobile sites and mobile
              applications. Any browser visiting these sites will receive
              cookies from us which helps us identify you more quickly when you
              return. Cookies help us to determine which pages or information
              you find most useful or interesting on our own websites.
              <br />
              {DOMAIN} may also have some cookies for its own analytics i.e.,
              analytics not part of Google Analytics. Such cookies help generate
              statistics and reports about visitors and their activities on the
              website or app.
            </>
          }
        />

        <Paragraph
          title="e. How are cookies used for online analytics purposes?"
          body={
            <>
              We may use web analytics services on {DOMAIN}, such as those of
              Google Analytics. These services help us analyse how users use the
              services, including by noting the third-party website from which
              you arrive. The information collected by the technology will be
              disclosed to or collected directly by such service providers, who
              use the information to evaluate your use of the services. We also
              use Google Analytics for certain purposes related to online
              marketing, as described in the following sections.
            </>
          }
        />

        <Paragraph
          title="f. How are cookies used for advertising purposes?"
          body={
            <>
              Cookies and other ad technology such as beacons, pixels, and tags
              help us serve relevant ads to you more effectively. They also help
              us provide aggregated auditing, research, and reporting for
              advertisers, understand and improve our service, and know when
              content has been shown to you. We work with website analytics and
              advertising partners, including Google Display Network, Facebook,
              etc. to deliver {DOMAIN} advertisements on third party publisher
              websites - these partners may set cookies on your computer&apos;s
              web browser. These cookies allow our partners to recognize your
              computer so that the ad server can show you {DOMAIN}{' '}
              advertisements elsewhere on the Internet, and so that our
              analytics software can measure your engagement and interactions
              while using {DOMAIN} services. In this way, ad servers may compile
              anonymous, de-identified information about where you, or others
              who are using your computer, saw our advertisements, whether or
              not you interacted with our advertisements, and actions performed
              on subsequent visits to {DOMAIN} websites and applications. This
              information allows an ad network to deliver targeted
              advertisements that they believe will be of most interest to you,
              and it allows {DOMAIN} to optimize the performance of our
              advertising campaigns and the usability of our website. In other
              words, we use analytics data in concert with data about our online
              ads that have been shown using the Google Display Network,
              Facebook for Advertisers, or other online advertising networks. By
              doing so, we can understand how anonymous users interacted with
              our website after seeing our ads.
            </>
          }
        />

        <Paragraph
          title={<>g. What third-party cookies does {DOMAIN} use?</>}
          body={
            <>
              Please note that the third parties (advertising networks and
              providers of external services like web traffic analysis services)
              may also use cookies on our Services. Cookies on our sites. Also,
              note that the names of cookies, pixels and other technologies may
              change over time.
              <br />
              We use trusted partners to help us service advertising, who may
              place cookies on your device. We also pull through content from
              social networks into our own pages, such as embedded Facebook
              feeds. The social networks, such as Facebook, Google, etc. may
              themselves also put cookies on your machine. If a user logs into
              Facebook, Twitter or Google+ via our website, they will leave a
              cookie on the user&apos;s computer. This is the same process as if
              the user logs into these social networks directly.
              <br />
              We also use Google Analytics on our Services to help us analyse
              how our Services are used. Google Analytics uses performance
              cookies to track customer&apos;s interactions. For example, by
              using cookies, Google can tell us which pages our users view,
              which are most popular, what time of day our websites are visited,
              whether visitors have been to our websites before, what website
              referred the visitor to our websites, and other similar
              information. All of this information is anonymized.
              <br />
              We suggest that you should check the respective privacy policies
              for these external services to help you understand what data these
              organizations hold about you and how they process it.
              <br />
              Facebook:&nbsp;
              <Link href="https://www.facebook.com/policy.php" target="_blank">
                <Typography
                  component={'span'}
                  sx={{
                    color: 'primary.main',
                    fontSize: '14px',
                  }}
                >
                  https://www.facebook.com/policy.php
                </Typography>
              </Link>
              <br />
              AdSense:&nbsp;
              <Link
                href="https://policies.google.com/technologies/ads"
                target="_blank"
              >
                <Typography
                  component={'span'}
                  sx={{
                    color: 'primary.main',
                    fontSize: '14px',
                  }}
                >
                  https://policies.google.com/technologies/ads
                </Typography>
              </Link>
              <br />
              Google Analytics:&nbsp;
              <Link
                href="https://www.google.com/analytics/learn/privacy.html"
                target="_blank"
              >
                <Typography
                  component={'span'}
                  sx={{
                    color: 'primary.main',
                    fontSize: '14px',
                  }}
                >
                  https://www.google.com/analytics/learn/privacy.html
                </Typography>
              </Link>
              <br />
              Google Tag Manager:&nbsp;
              <Link
                href="https://www.google.com/analytics/tag-manager/faq/"
                target="_blank"
              >
                <Typography
                  component={'span'}
                  sx={{
                    color: 'primary.main',
                    fontSize: '14px',
                  }}
                >
                  https://www.google.com/analytics/tag-manager/faq/
                </Typography>
              </Link>
              <br />
              Google+:&nbsp;
              <Link
                href="https://www.google.com/policies/privacy/"
                target="_blank"
              >
                <Typography
                  component={'span'}
                  sx={{
                    color: 'primary.main',
                    fontSize: '14px',
                  }}
                >
                  https://www.google.com/policies/privacy/
                </Typography>
              </Link>
              <br />
              Twitter:&nbsp;
              <Link href="https://twitter.com/en/privacy" target="_blank">
                <Typography
                  component={'span'}
                  sx={{
                    color: 'primary.main',
                    fontSize: '14px',
                  }}
                >
                  https://twitter.com/en/privacy
                </Typography>
              </Link>
              <br />
              Google Double click:&nbsp;
              <Link
                href="https://support.google.com/dfp_premium/answer/2839090?hl=en"
                target="_blank"
              >
                <Typography
                  component={'span'}
                  sx={{
                    color: 'primary.main',
                    fontSize: '14px',
                  }}
                >
                  https://support.google.com/dfp_premium/answer/2839090?hl=en
                </Typography>
              </Link>
            </>
          }
        />

        <Paragraph
          title="h. What are Web Beacons?"
          body={
            <>
              {DOMAIN} occasionally advertises on third party websites. As part
              of our effort to track the success of our advertising campaigns,
              we may at times use a visitor identification technology such as
              &quot;web beacons,&quot; or &quot;action tags,&quot; which count
              visitors who have come to our site after being exposed to a{' '}
              {DOMAIN} banner ad on a third-party site. Our partners may also
              use web beacons to collect data in the aggregate as provided by
              your browser while you are on our site or another site where{' '}
              {DOMAIN} is a third party.
              <br />
              By navigating on our site, you agree that we can place cookie and
              web beacons on your computer or device. If you prefer not to
              receive web beacons, then you should stop using our site, or
              consult your browsing settings.
            </>
          }
        />

        <Paragraph
          title="i. How to control cookies?"
          body={
            <>
              Most browsers allow you to control cookies through their settings
              preferences. However, if you choose to turn off these cookies, you
              will still see advertising on the internet but it may not be
              tailored to your interests. It does not mean that you won&apos;t
              be served any advertisements whilst you are online. Whilst we have
              mentioned most of the third parties involved in using targeting or
              advertising cookies in the preceding section, the list is not
              exhaustive and is subject to change. Therefore, even if you choose
              to turn off all the third-party cookies listed in the section, you
              may still receive some tailored advertisements and
              recommendations.
              <br />
              There are a number of ways you can manage what cookies are set on
              your devices. Essential cookies, however, cannot be disabled. If
              you do not allow certain cookies to be installed, the website may
              not be accessible to you and/or the performance, features, or
              services of the website may be compromised.
              <br />
              You can also manage this type of cookie in the privacy settings on
              the web browser you are using. Please note that if you use your
              browser settings to block all cookies you may not be able to
              access parts of our or other&apos;s websites. Please see below for
              more information.
              <br />
              <i>Changing your Cookie Settings:</i>&nbsp;The browser settings
              for changing your cookies settings are usually found in the
              &apos;options&apos; or &apos;preferences&apos; menu of your
              internet browser. In order to understand these settings, the
              following links may be helpful. Otherwise, you should use the
              &apos;Help&apos; option in your internet browser for more details.
              <ul>
                <li>
                  <Link
                    href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies"
                    target="_blank"
                  >
                    <Typography
                      component={'span'}
                      sx={{
                        color: 'primary.main',
                        fontSize: '14px',
                      }}
                    >
                      Cookie settings in Internet Explorer
                    </Typography>
                  </Link>
                </li>
                <li>
                  <Link
                    href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
                    target="_blank"
                  >
                    <Typography
                      component={'span'}
                      sx={{
                        color: 'primary.main',
                        fontSize: '14px',
                      }}
                    >
                      Cookie settings in Firefox
                    </Typography>
                  </Link>
                </li>
                <li>
                  <Link
                    href="https://support.google.com/chrome/answer/95647"
                    target="_blank"
                  >
                    <Typography
                      component={'span'}
                      sx={{
                        color: 'primary.main',
                        fontSize: '14px',
                      }}
                    >
                      Cookie settings in Chrome
                    </Typography>
                  </Link>
                </li>
                <li>
                  <Link
                    href="https://support.apple.com/en-in/guide/safari/sfri11471/mac"
                    target="_blank"
                  >
                    <Typography
                      component={'span'}
                      sx={{
                        color: 'primary.main',
                        fontSize: '14px',
                      }}
                    >
                      Cookie settings in Safari
                    </Typography>
                  </Link>
                </li>
              </ul>
              <i>More information:</i>&nbsp;To find out more about cookies,
              including how to see what cookies have been set and how to manage
              and delete them, visit&nbsp;
              <Link href="https://www.allaboutcookies.org/" target="_blank">
                <Typography
                  component={'span'}
                  sx={{
                    color: 'primary.main',
                    fontSize: '14px',
                  }}
                >
                  www.allaboutcookies.org
                </Typography>
              </Link>
              .&nbsp;You can learn more about opting out of receiving
              interest-based ads from other companies at&nbsp;
              <Link href="https://optout.aboutads.info/" target="_blank">
                <Typography
                  component={'span'}
                  sx={{
                    color: 'primary.main',
                    fontSize: '14px',
                  }}
                >
                  optout.aboutads.info
                </Typography>
              </Link>
              &nbsp;and&nbsp;
              <Link
                href="https://www.networkadvertising.org/choices"
                target="_blank"
              >
                <Typography
                  component={'span'}
                  sx={{
                    color: 'primary.main',
                    fontSize: '14px',
                  }}
                >
                  www.networkadvertising.org/choices
                </Typography>
              </Link>
              .&nbsp;In addition, certain third-party advertising networks, like
              Facebook (pixels) and Google, permit users to opt out of or
              customize preferences associated with your internet browsing. To
              learn more about this feature from Google, click here. For further
              information about the Facebook Pixel, click&nbsp;
              <Link
                href="https://www.facebook.com/business/help/651294705016616"
                target="_blank"
              >
                <Typography
                  component={'span'}
                  sx={{
                    color: 'primary.main',
                    fontSize: '14px',
                  }}
                >
                  here
                </Typography>
              </Link>
              .
            </>
          }
        />
      </Card>
    </Box>
  );
};

export default CookiePolicyPage;
